(() => {
  const policy = 'momway-cart-email-v1-20261016';
  const storageKey = 'momway-email-accepted-v1';
  const previousStorageKey = 'momway-email-declined-v1';
  const initialized = new WeakMap();
  let continuingDrawer = false;
  let drawerRefreshTimer;
  const observedDrawers = new WeakSet();
  let queue = Promise.resolve();
  function initialize(root) {
    if (initialized.has(root)) { initialized.get(root).show(); return; }
    const box = root.querySelector('[data-momway-accepted]');
    const field = root.querySelector('[data-momway-declined-field]');
    const policyField = root.querySelector('[data-momway-policy-field]');
    const shownField = root.querySelector('[data-momway-shown-field]');
    const status = root.querySelector('[data-momway-save-status]');
    const form = root.closest('form');
    const stored = (() => { try { return localStorage.getItem(storageKey); } catch { return null; } })();
    const previouslyDeclined = (() => { try { return localStorage.getItem(previousStorageKey) === 'true'; } catch { return true; } })();
    box.checked = stored === 'true' && !previouslyDeclined;
    box.removeAttribute('name');
    field.disabled = false;
    let shownAt = '';
    function save() {
      field.value = String(!box.checked);
      const attributes = {momway_email_policy: shownAt ? policy : '', momway_email_shown_at: shownAt, momway_email_declined: field.value};
      queue = queue.catch(() => {}).then(async () => {
        try {
          const cart = await new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', `${window.Shopify?.routes?.root || '/'}cart/update.js`);
            request.setRequestHeader('Content-Type', 'application/json');
            request.responseType = 'json';
            request.timeout = 15000;
            request.onload = () => request.status >= 200 && request.status < 300 && request.response ? resolve(request.response) : reject(new Error('cart'));
            request.onerror = request.ontimeout = () => reject(new Error('cart'));
            request.send(JSON.stringify({attributes}));
          });
          if (Object.entries(attributes).some(([key, value]) => String(cart.attributes?.[key] || '') !== value)) throw new Error('attributes');
          status.textContent = '';
          return true;
        } catch {
          status.textContent = root.dataset.saveFailed;
          return false;
        }
      });
      return queue;
    }
    field.value = String(!box.checked);
    box.addEventListener('change', () => {
      try {
        localStorage.setItem(storageKey, String(box.checked));
        localStorage.setItem(previousStorageKey, String(!box.checked));
      } catch {}
      document.querySelectorAll('[data-momway-accepted]').forEach(other => { other.checked = box.checked; });
      save();
    });
    const show = () => {
      if (shownAt || document.visibilityState !== 'visible') return;
      const rect = root.getBoundingClientRect();
      const top = Math.max(0, rect.top), bottom = Math.min(innerHeight, rect.bottom);
      if (bottom - top < rect.height * 0.5) return;
      const x = Math.min(innerWidth - 1, Math.max(0, rect.left + rect.width / 2));
      if (![0.2, 0.5, 0.8].every(fraction => root.contains(document.elementFromPoint(x, top + (bottom - top) * fraction)))) return;
      shownAt = new Date().toISOString();
      policyField.value = policy;
      shownField.value = shownAt;
      save();
    };
    initialized.set(root, {show, save});
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5)) { show(); observer.disconnect(); }
      }, {threshold: 0.5});
      observer.observe(root);
    }
    let continuing = false;
    form?.addEventListener('submit', async event => {
      if (continuing) return;
      const submitter = event.submitter;
      if (submitter?.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const success = await save();
      if (!success) return;
      continuing = true;
      form.requestSubmit(submitter);
    }, true);
  }
  function refreshDrawer() {
    const root = document.querySelector('#kaching-cart [data-momway-drawer-choice]');
    if (!root) return;
    const request = new XMLHttpRequest();
    request.open('GET', `${window.Shopify?.routes?.root || '/'}cart.js`);
    request.responseType = 'json';
    request.timeout = 15000;
    request.onload = () => {
      if (request.status < 200 || request.status >= 300 || !request.response?.items) return;
      const cart = request.response;
      const total = cart.items.filter(item => String(item.vendor).trim().toLowerCase() === 'momway').reduce((sum, item) => sum + item.final_line_price, 0);
      root.hidden = total <= 0;
      if (root.hidden) return;
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'lt', {style: 'currency', currency: cart.currency || 'EUR'}).format(Math.round(total * 0.1) / 100);
      const estimate = root.querySelector('[data-momway-estimate]');
      const content = root.dataset.estimateTemplate.replace('__AMOUNT__', amount);
      if (estimate.textContent !== content) estimate.textContent = content;
      initialize(root);
    };
    request.send();
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('#kaching-cart__checkout-button');
    if (!button) return;
    if (continuingDrawer) { continuingDrawer = false; return; }
    const root = document.querySelector('#kaching-cart [data-momway-drawer-choice]');
    if (!root || root.hidden) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const state = initialized.get(root);
    state.show();
    if (!await state.save()) return;
    const next = document.getElementById('kaching-cart__checkout-button');
    if (next) { continuingDrawer = true; next.click(); }
  }, true);
  function scan() {
    document.querySelectorAll('[data-momway-choice]').forEach(initialize);
    const drawer = document.getElementById('kaching-cart');
    const button = document.getElementById('kaching-cart__checkout-button');
    const template = document.getElementById('momway-drawer-template');
    if (!drawer || !button || !template) return;
    if (!drawer.querySelector('[data-momway-drawer-choice]')) {
      button.parentElement.insertBefore(template.content.cloneNode(true), button);
      refreshDrawer();
    }
    if (!observedDrawers.has(drawer)) {
      observedDrawers.add(drawer);
      new MutationObserver(mutations => {
        if (mutations.every(mutation => mutation.target.closest?.('[data-momway-drawer-choice]'))) return;
        clearTimeout(drawerRefreshTimer);
        drawerRefreshTimer = setTimeout(refreshDrawer, 150);
      }).observe(drawer, {childList: true, subtree: true});
    }
  }
  scan();
  new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
})();
